import * as React from "react";
import { Box } from "../../../styles/DailyRecord";
import { Dropdown } from "antdv5";
import DatePicker from "react-datepicker";
import { DownOutlined } from "@ant-design/icons";
import type { MenuProps } from "antdv5";
import type { IMessageTBGroup } from "../../../api_types";
import { color } from "../../../styles/color";
import { useHistory } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import type { SetState, ITableFilters, Fn } from "../../../client_types";
import { context } from "../../context/Context";

interface IProps {
  clubList: IMessageTBGroup[];
  nowClub: string;
  findName: ITableFilters;
  lockInput: boolean;
  startDate: Date | null;
  endDate: Date | null;
  inputRef: React.MutableRefObject<HTMLInputElement | null>;
  setNowClub: SetState<string>;
  setClubGid: SetState<string>;
  setFindName: SetState<ITableFilters>;
  setDateRange: SetState<[Date | null, Date | null]>;
  setLock: SetState<boolean>;
  handleSearch: Fn;
  handleEnter: (e: React.KeyboardEvent, fn: Fn) => void;
  handleDateSelect: () => (Date | null)[];
}

interface ReadonlyInputProps {
  value: any;
  onClick: (e?: React.MouseEvent) => void;
}
const ReadonlyInput = React.forwardRef(
  ({ value, onClick }: ReadonlyInputProps, ref: any) => (
    <div
      className="customInput resized"
      onClick={onClick}
      ref={ref}
      style={{ color: value ? "black" : `${color.default}` }}
    >
      {value ? value : "起始日期 - 结束日期"}
    </div>
  )
);

const Searchbox = ({
  clubList,
  nowClub,
  setNowClub,
  setClubGid,
  setFindName,
  findName,
  lockInput,
  handleSearch,
  endDate,
  handleEnter,
  startDate,
  setDateRange,
  setLock,
  inputRef,
  handleDateSelect,
}: IProps) => {
  const [items, setItems] = React.useState<MenuProps["items"]>([]);
  const { dispatch } = React.useContext(context);
  const history = useHistory();

  React.useEffect(() => {
    let clubs: any[] = [];
    if (localStorage.getItem("character") === "Admin") {
      clubs = clubList;
    } else {
      clubs = clubList.filter(
        (c: any) => c.Gid === Number.parseInt(localStorage.getItem("gid") || "")
      );
    }
    setItems(
      clubs.map((d, i) => ({
        key: i.toString(),
        label: (
          <div
            onClick={() => {
              setNowClub(`${d.Clubid} - ${d.ClubName}`);
              setClubGid(d.Gid);
              history.push(`${d.Clubid}`);
              dispatch({ clubID: d.Clubid });
              localStorage.setItem("clubName", d.ClubName);
              localStorage.setItem("gid", d.Gid);
            }}
            key={d.Gid}
            style={{ color: `${color.markedSecondary}` }}
          >
            {d.Clubid} - {d.ClubName}
          </div>
        ),
      }))
    );
  }, [clubList]);
  return (
    <div className="searchBox">
      <Box>
        <Dropdown menu={{ items }}>
          <div
            className="ant-dropdown-link"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            {nowClub} <DownOutlined />
          </div>
        </Dropdown>
      </Box>
      <div className="inputBox">
        <input
          className="input"
          type="text"
          onChange={(e) => {
            setFindName({ ...findName, searchName: e.target.value });
          }}
          placeholder={"参赛编号"}
          value={findName.searchName}
          onKeyPress={(e) => handleEnter(e, handleSearch)}
          disabled={lockInput || endDate === null}
        />
        <input
          className="input"
          type="text"
          onChange={(e) => {
            setFindName({ ...findName, memberName: e.target.value });
          }}
          placeholder={"参赛名称"}
          value={findName.memberName}
          onKeyPress={(e) => handleEnter(e, handleSearch)}
          disabled={lockInput || endDate === null}
        />
        <input
          className="input"
          type="text"
          onChange={(e) => {
            setFindName({
              ...findName,
              searchFeetNo: e.target.value,
            });
          }}
          placeholder={"足环号"}
          value={findName.searchFeetNo}
          onKeyPress={(e) => handleEnter(e, handleSearch)}
          disabled={lockInput || endDate === null}
        />
      </div>
      <div className={lockInput ? "dateDisabled dateOutter" : "dateOutter"}>
        <DatePicker
          selectsRange={true}
          startDate={startDate}
          endDate={endDate}
          onChange={(update) => {
            setDateRange(update);
          }}
          isClearable={true}
          minDate={startDate}
          maxDate={new Date()}
          fixedHeight
          dateFormat="yyyy-MM-dd"
          showPopperArrow={false}
          locale="zh"
          todayButton="今日"
          customInput={
            <ReadonlyInput
              value=""
              onClick={() => console.log("placeholder")}
            />
          }
          onInputClick={() => {
            setDateRange([null, null]);
            setLock(true);
            setFindName({
              searchFeetNo: "",
              searchName: "",
              memberName: "",
            });
          }}
          disabled={lockInput}
          includeDates={
            startDate !== null ? (handleDateSelect() as Date[]) : undefined
          }
          ref={inputRef as any}
        />
      </div>
    </div>
  );
};

export default Searchbox;
